import { z } from "@/zod";
import { PHONE_NUMBER_REGEX } from "@/constants";
import { t } from "i18next";

export const phoneNumber = z
  .string()
  .regex(PHONE_NUMBER_REGEX, t("validation.phone_number.invalid_format"));

export const phoneNumberOptional = z
  .union([z.literal(""), phoneNumber])
  .nullish();
